export const getFileExtension = (filename: string): string =>
  filename === 'temp'
    ? 'png'
    : filename.substring(filename.lastIndexOf('.') + 1, filename.length) ||
      filename;
